<template>
  <div class="money-market-calculator">
    <moneymarket-calculator
      :disclaimer="disclaimer"
      :defaultvalue="defaultvalue"
      :zipcodelocationerror="zipcodelocationerror"
    ></moneymarket-calculator>
  </div>
</template>

<script>
import MoneyMarketCalculator from "./components/moneyMarketCalculator.vue";

export default {
  components: {
    'moneymarket-calculator': MoneyMarketCalculator
  },
  data() {
    return {
      disclaimer: this.disclaimerText,
      defaultvalue: this.defaultvalueText,
      zipcodelocationerror: this.zipcodelocationerrorText, 
    }
  },
  mounted() {
      // this is an old comment - need to check for data here so we can remove the timeout
  },
 props: {
    disclaimerText: String,
    defaultvalueText: String,
    zipcodelocationerrorText: String,
  }
};
</script>
